module.exports = __webpack_public_path__ + "static/media/4ODA2.d8047db3.jpg";